import React from "react";
import parser from "html-react-parser";

// CR-02: an answer was a grey strip with a transparent border, so there was nothing to
// show it was a box you could click until you had already clicked it. It now carries a
// visible outline at rest, lifts on hover, and fills in when chosen.
// CR-04: the text is aligned to the start of the line. It was inheriting the button
// element's centred default, which left short answers floating in the middle of the row
// and made a column of them impossible to scan.
export const AnswerCard = ({ text, selected, onSelect }) => {
  return (
    <button
      // Formik renders its children inside a plain div here, but a bare <button> still
      // defaults to type="submit". Being explicit keeps that true if the markup around
      // it ever becomes a real form.
      type="button"
      onClick={onSelect}
      aria-pressed={selected}
      className={`relative px-7 py-4 rounded-lg leading-none flex items-center m-2 w-full border-2 cursor-pointer text-start transition-colors duration-150 ${
        selected
          ? "border-blue-500 bg-blue-50 shadow-sm"
          : "border-slate-300 bg-slate-50 hover:border-blue-400 hover:bg-white hover:shadow-md"
      }`}
    >
      <span
        className={`lg:text-lg sm:text-sm text-slate-900 text-start w-full ${
          selected ? "font-semibold" : "font-medium"
        }`}
      >
        {parser(text)}
      </span>
    </button>
  );
};
